import {SectionType} from './../ek-e-commerce/ek-models/section-type.model';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
// import { AppConfig, APP_CONFIG } from './config';
// @ts-ignore
import {BehaviorSubject, Observable} from "rxjs";
import {ADMIN_CONFIG} from "../../../environments/environment";
import {ocrInfo} from "../ek-e-commerce/ek-models/document-ocr-information";
import {DocumentModel} from "../ek-e-commerce/ek-models/document.model";
import {Response} from "../ek-e-commerce/ek-models/response.model";
import {VerificationFullObject} from "../ek-e-commerce/ek-models/ocr-validations";

// import {ShippingAddressFolder} from "../Models/shipping-address-folder";

@Injectable({providedIn: "root"})
export class DocumentService {
    currentRole = '';
    docStateSbj$ = new BehaviorSubject<string>(null)
    public docStateObs$ = this.docStateSbj$.asObservable()
    basicUrl: string;
    documentUrl: string;
    documentClientUrl: string;
    folderUrl: string;
    // Subjects
    public ocrSubject: BehaviorSubject<ocrInfo> = new BehaviorSubject<ocrInfo>(
        null as any
    );
    isBankDocCheckedSubject = new BehaviorSubject<boolean>(false);
    allOneByOneIsCheckedSubject = new BehaviorSubject<boolean>(false);
    currentDocSbj$ = new BehaviorSubject<DocumentModel>(null);
    currentDocumentObs$ = this.currentDocSbj$.asObservable()
    private isFilesChanges$ = new BehaviorSubject<boolean>(false);
    public filesChange$ = this.isFilesChanges$.asObservable();

    constructor(private http: HttpClient) {
        this.basicUrl = `${ADMIN_CONFIG.apiEndpoint}`;
        this.documentUrl = `${ADMIN_CONFIG.apiEndpoint}document`;
        this.documentClientUrl = `${ADMIN_CONFIG.apiEndpoint}documentClient`;
        this.folderUrl = `${ADMIN_CONFIG.apiEndpoint}shippingAddressFolder`;
        this.currentRole = JSON.parse(localStorage.getItem('currentUser')).roles;
    }

    _profSituation!: string;

    get profSituation(): string {
        return this._profSituation;
    }

    set profSituation(value: string) {
        this._profSituation = value;
    }

    _personnalSituation!: string;

    get personnalSituation(): string {
        return this._personnalSituation;
    }

    set personnalSituation(value: string) {
        this._personnalSituation = value;
    }

    public uploadCrempaComplementDocument(file: File, folderId: number) {
        const url = `${this.documentUrl}/crempa-additional-information/${folderId}`;
        const formData = new FormData();
        formData.append("file", file, file.name);
        return this.http.post<Response<any>>(url, formData);
    }

    public uploadDocument(file: File, document: DocumentModel) {
        const url = `${this.documentUrl}/new/save`;
        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("document", JSON.stringify(document));
        this.isFilesChanges$.next(true);
        return this.http.post<Response<any>>(url, formData);
    }

    public uploadProfileDocument(file: File, document: DocumentModel) {
        const url = `${this.documentClientUrl}`;
        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("document", JSON.stringify(document));
        return this.http.post<Response<any>>(url, formData);
    }

    public updateDocument(file: File, document: DocumentModel) {
        const url = `${this.documentUrl}/new`;
        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("document", JSON.stringify(document));
        this.isFilesChanges$.next(true);
        return this.http.put<Response<any>>(url, formData);
    }

    public updateProfileDocument(file: File, document: DocumentModel) {
        const url = `${this.documentClientUrl}`;
        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("document", JSON.stringify(document));
        return this.http.put<Response<any>>(url, formData);
    }

    public deleteDocument(id: number) {
        const url = `${this.documentUrl}/delete/${id}`;
        this.isFilesChanges$.next(true);
        return this.http.delete<Response<any>>(url);
    }

    public getPercentageByOrderId(id: number) {
        const url = `${this.documentUrl}/pourcentage/${id}`;
        return this.http.get<Response<any>>(url);
    }

    public getDocumentsByFolderId(id: number) {
        const url = `${this.documentUrl}/folder/${id}`;
        return this.http.get<Response<any>>(url);
    }

    /**
     * Lists the standalone empty bank templates (BANK_EMPTY, folder = null).
     * GET /document/standalone/empty?type=BANK_EMPTY
     */
    public getEmptyBankTemplates() {
        const url = `${this.documentUrl}/standalone/empty`;
        const params = new HttpParams().set('type', 'BANK_EMPTY');
        return this.http.get<Response<any>>(url, {params});
    }



    /**
     * Saves a standalone empty bank template (no folder) — single upsert API
     * used for both create and update. The backend updates the existing row when
     * one matches (folder IS NULL + type + gender), otherwise creates it.
     * POST /document/standalone/save
     */
    public saveStandaloneDocument(file: File, document: DocumentModel) {
        const url = `${this.documentUrl}/standalone/save`;
        const formData = new FormData();
        formData.append("files", file, file.name);
        formData.append("document", JSON.stringify(document));
        return this.http.post<Response<any>>(url, formData);
    }

    public getFilledGuarantees(id: number) {
        const url = `${this.documentUrl}/guarantees/folder/${id}`;
        return this.http.get<any>(url);
    }


    public sendGuaranteesToEtayssir(id: number) {
        const url = `${this.documentUrl}/${id}/guarantees/signed/send-to-etaysir`;
        return this.http.post(url, {}, {responseType: 'text'});
    }

    public sendInvoicesToEtayssir(id: number) {
        const url = `${this.documentUrl}/${id}/Invoices/signed/send-to-etaysir`;
        return this.http.post(url, {}, {responseType: 'text'});
    }


    public verifyOcr(folderId: number, feedBack: boolean) {
        const url = `${this.documentUrl}/verifyOcr/${folderId}`;
        const params = new HttpParams().set('aBoolean', String(feedBack));
        return this.http.get<Response<any>>(url, {params});
    }

    public downloadDocuments(documentType: string, orderId: number) {

        const url = `${this.documentUrl}/bank/${orderId}`;
        const params = new HttpParams().set('type', documentType);
        return this.http.get<Response<any>>(url, {params});
    }

    public checkDocuments(folderId: number) {
        const url = `${this.basicUrl}OCR/allDocument/${folderId}`;
        return this.http.get<Response<any>>(url);
    }

    public getShippingAddressFolder(folderId: number) {
        const url = `${this.folderUrl}/folder/${folderId}`;
        return this.http.get<Response<any>>(url);
    }

    public checkBankDocuments(folderId: number) {
        const params = new HttpParams().set("type", "BANK");
        const url = `${this.basicUrl}document/check/${folderId}`;
        return this.http.get<Response<any>>(url, {params});
    }

    public checkGuaranteesDocuments(folderId: number) {
        const params = new HttpParams().set("type", "GUARANTEES");
        const url = `${this.basicUrl}document/check/${folderId}`;
        return this.http.get<Response<any>>(url, {params});
    }

    public checkInvoiceDocuments(folderId: number) {
        const params = new HttpParams().set("type", "INVOICE");
        const url = `${this.basicUrl}document/check/${folderId}`;
        return this.http.get<Response<any>>(url, {params});
    }

    public getDocumentById(id: number): Observable<Response<DocumentModel>> {
        const url = `${this.documentUrl}/${id}`;
        return this.http.get<Response<DocumentModel>>(url);
    }

    public updateDocumentState(idDoc: number, state: string, openAt: string) {
        const url = `${this.documentUrl}/state/${idDoc}?state=${state}&openAt=${openAt}`;
        return this.http.patch<Response<any>>(url, {});
    }

    public getValidationResponse(folderId: number) {
        const url = `${this.basicUrl}OCR/reponse/${folderId}`;
        return this.http.get<Response<VerificationFullObject>>(url);
    }

    public getClientInfo(folderId: number) {
        const url = `${ADMIN_CONFIG.apiEndpoint}clientInformation/findClientInfoByIdFolder/${folderId}`;
        return this.http.get<Response<ocrInfo | any>>(url);
    }

    public verifyDocuments(folderId: number) {
        const url = `${ADMIN_CONFIG.apiEndpoint}OCR/checkDocument/admin/${folderId}`;
        return this.http.get<Response<any>>(url);
    }

    public downloadFiles(idFolder: number, sectionType: SectionType) {
        if (this.currentRole !== 'ROLE_POS_EK') {
            const url = `${this.documentUrl}/pdf/getAllFiles/${sectionType}/${idFolder}`;
            return this.http.get<any>(url);
        }
    }

    public getNotifDate(idFolder: number): Observable<Response<string>> {
        const url = `${this.basicUrl}historyStateFolder/bank-notification-date/${idFolder}`;
        return this.http.get<Response<string>>(url)
    }

    downloadFile(url: string, fileName: string) {
        if (!url) {
            return;
        }
        this.http.get(url, {responseType: 'blob'}).subscribe(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(blobUrl);
        });
    }
}
